<template>
  <v-container fluid>
    <div v-if="$vuetify.breakpoint.smAndUp"
         :style="{position: 'absolute', top: '1px', right: '10px'}">
      <gallery-view-buttons></gallery-view-buttons>
    </div>

    <v-row>
      <v-col cols="12" sm="4" md="3" style="border-right: 1px solid lightgray">

        <v-row class="py-0 ">
          <!--FILTER-->
          <v-col cols="12">
            <product-filters
                v-model="filters"
                vertical
            />
          </v-col>

          <!--CART-->
          <v-col
              v-if="$vuetify.breakpoint.smAndUp"
              cols="12" class="pb-0"
          >
            <customer-cart-detail></customer-cart-detail>
          </v-col>
        </v-row>


      </v-col>

      <!--PRODUCTS-->
      <v-col cols="12" sm="8" :md="9" class="pt-0">

        <loading v-if="loading"></loading>
        <v-row v-if="stock && getActivePromos.length > 0">
          <v-col cols="12">
            <h5 class="grey--text text--darken-4 font-weight-bold" :class="{['text-h5']: $vuetify.breakpoint.xs, ['text-h4']: $vuetify.breakpoint.smAndUp}">Promos</h5>
            <v-divider></v-divider>
          </v-col>

          <!--PROMOS-->
          <v-col cols="12">
            <v-row>
              <v-col v-for="promo in getActivePromos"
                     :key="promo.id"
                     cols="12" :sm="6" :md="4"
              >
                <promo-card
                    :promo="promo"
                    :stock="stock"
                    :quantity="getPromoQuantity(promo)"
                />
              </v-col>
            </v-row>

          </v-col>
        </v-row>

        <v-row
            v-for="category in categories"
            :key="'c'+category.id"
            :id="'c'+category.id"
            v-intersect="{handler: onIntersect, options: {threshold:[0, 0.05,0.08,0.1, 0.2, 0.225, 0.25, 0.5, 0.75, 1]}}"
        >

          <v-col cols="12">
            <h5 class="grey--text text--darken-4 font-weight-bold" :class="{['text-h5']: $vuetify.breakpoint.xs, ['text-h4']: $vuetify.breakpoint.smAndUp}" >{{ category.name }}</h5>

            <customer-category-quantity :category="category"></customer-category-quantity>

            <v-divider></v-divider>
          </v-col>

          <template v-if="!hasCategoryProducts(category)">
            <v-alert type="info">
              No se encontraron productos con los criterios seleccionados
            </v-alert>
          </template>

          <template v-else>
            <template
              v-for="(item, index) in getProductsByCategory(category)"
            >
              <v-col
                :key="index"
                v-if="productIsAvailable(item.product)"
                cols="12" :sm="$store.getters.galleryView"
              >
                <customer-product-card
                    :product="item.product"
                    :category="category"
                    :order="item.order"
                    :quantity="getItemQuantity(item.product, category)"
                    :stock-quantity="item.quantity"
                    edit-quantity
                />
              </v-col>
            </template>
          </template>


        </v-row>

      </v-col>


    </v-row>

    <customer-navigation-cart-detail
        v-model="showCart"
        @next="next">
    </customer-navigation-cart-detail>

    <div class="text-right pa-3">
      <v-btn
          @click="showCart=!showCart"
          class="primary onPrimary--text "
      >
        <v-icon left>shopping_cart</v-icon>
        {{ $t('common.next') }}
      </v-btn>
    </div>

    <cart-button
        :total="$store.getters.orderSystem.getTotalQuantity"
        @click="showCart=!showCart"
    ></cart-button>
  </v-container>
</template>

<script>
import ProductFilters from "@/modules/delivery/components/ProductFilters/ProductFilters";
import {Loading} from "@dracul/common-frontend"
import GalleryViewButtons from "@/modules/delivery/components-core/shared/GalleryViewButtons/GalleryViewButtons";
import StockProvider from "@/modules/delivery/providers/StockProvider";
import CustomerCategoryQuantity
  from "@/modules/delivery/components-core/customer/CustomerCategoryQuantity/CustomerCategoryQuantity.vue";
import CustomerProductCard
  from "@/modules/delivery/components-core/customer/CustomerProductCard/CustomerProductCard.vue";
import PromoCard from "@/modules/delivery/components-core/shared/PromoCard/PromoCard.vue";
import CustomerCartDetail from "@/modules/delivery/components-core/customer/CustomerCartDetail/CustomerCartDetail.vue";
import CustomerNavigationCartDetail
  from "@/modules/delivery/components-core/customer/CustomerNavigationCartDetail/CustomerNavigationCartDetail.vue";
import CartButton from "@/modules/delivery/components/CartButton/CartButton.vue";
import StockMixin from "@/modules/delivery/mixins/StockMixin";

export default {
  name: "CustomerProductGallery",
  components: {
    CartButton,
    CustomerNavigationCartDetail,
    CustomerCartDetail,
    CustomerProductCard,
    CustomerCategoryQuantity,
    PromoCard,
    GalleryViewButtons,
    ProductFilters,
    Loading
  },
  mixins: [StockMixin],
  data() {
    return {
      showCart: false,
      stock: null,
      filters: {
        name: null,
        ingredients: [],
        category: null
      },
      loading: false
    }
  },
  created() {
    this.$store.dispatch('fetchCategories')
        .then(() => this.$store.commit('setExtensionMenu', this.getCategoriesMenu))

    this.$store.dispatch('fetchPromos')

    this.checkBranch().then(() => this.fetchStockProducts())
  },
  beforeDestroy() {
    this.$store.commit('setExtensionMenu', null)
  },
  computed: {
    branch() {
      return this.$store.getters.branchSelected
    },
    isDelivery() {
      return this.$store.getters.orderSystem.order.isDelivery
    },
    isTakeAway() {
      return this.$store.getters.orderSystem.order.isTakeAway
    },
    getOrderDeliveryMode() {
      const deliveryMode = this.$store.getters.orderSystem.order.getDeliveryMode
      if(deliveryMode) this.$store.getters.orderSystem.removeProductsByDeliveryMode(deliveryMode)
      return deliveryMode
    },
    productIsAvailable() {
      return (product) => {
        const deliveryMode = this.getOrderDeliveryMode === 'TAKE_AWAY' ? 'Take Away' : 'Delivery'
        const includeModes = product.salesChannelsConfig.web.modes.includes(deliveryMode)
        return includeModes
      }
    },
    categories() {
      return this.$store.getters.categories
    },
    getCategoriesMenu() {
      return this.$store.getters.categories.map(category => {
        return {icon: category.icon, name: category.name, ratio: 0, id: "c"+category.id}
      })
    },
    getOrderItems() {
      return this.$store.getters.orderSystem.order.items
    },
    getItemQuantity() {
      return (product, category) => {
        return this.$store.getters.orderSystem.cartService.getQuantityByProductAndCategory(product, category)
      }
    },
    getTotalItems() {
      return this.$store.getters.orderSystem.cartService.getItemsQuantity
    },
    getPromoQuantity() {
      return (promo) => {
        return this.$store.getters.orderSystem.cartService.getQuantityByPromo(promo)
      }
    },
    getOrderDateTime() {
      return this.$store.getters.orderSystem.order.getDateTime
    },
    getActivePromos() {
      let dt = this.getOrderDateTime
      return this.$store.getters.promos
          .filter(promo => {
            return promo.isActive() && promo.isActive(dt)
          })
          .filter(promo => {
            return promo.mode && promo.mode.length > 0 ? promo.mode.includes(this.getOrderDeliveryMode) : true
          })
    }
  },
  methods: {
    next() {
      this.showCart = false
      this.$emit('next')
    },
    onIntersect(entries) {
      entries.forEach(entry => {
        this.$store.commit('setExtensionMenuRatio', {id: entry.target.id, ratio: entry.intersectionRatio})
      })
    },
    async checkBranch() {
      if (!this.branch) {
        await this.$store.dispatch('fetchDefaultBranch')
      }
      return this.branch
    },

    fetchStockProducts() {
      this.loading = true
      if (this.branch) {
        StockProvider.findStockByBranch(this.branch.id)
            .then(r => {
              this.stock = {
                ...r.data.findStockByBranch,
                items: r.data.findStockByBranch.items.filter(item => {
                  const isFromWeb = item.product.salesChannelsConfig.web.enabled
                  return isFromWeb
                })
              }
            })
            .catch(e => {
              console.error(e)
            })
            .finally(() => this.loading = false)
      }
    }
  }
}
</script>

<style scoped>

</style>
